/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Tarjeta_Documentacion_Informacion from "../Tarjetas/Tarjeta_Documentacion_Informacion";
import {useEffect, useState} from "react";
import {obtenerColWheres} from "../../../../Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";

const documentos = [
    {
        nombre: 'Nombre Doc',
        parrafo: 'Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500, cuando un impresor (N. del ',
        ruta: 'Alert documentacion',
    },
    {
        nombre: 'Nombre Doc',
        parrafo: 'Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500, cuando un impresor (N. del ',
        ruta: 'Alert documentacion',
    },
    {
        nombre: 'Nombre Doc',
        parrafo: 'Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500, cuando un impresor (N. del ',
        ruta: 'Alert documentacion',
    },
    {
        nombre: 'Nombre Doc',
        parrafo: 'Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500, cuando un impresor (N. del ',
        ruta: 'Alert documentacion',
    },
    {
        nombre: 'Nombre Doc',
        parrafo: 'Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500, cuando un impresor (N. del ',
        ruta: 'Alert documentacion',
    },
    {
        nombre: 'Nombre Doc',
        parrafo: 'Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500, cuando un impresor (N. del ',
        ruta: 'Alert documentacion',
    }
]

const Lista_Tarjeta_Documentacion_Informacion = () => {
    const [reportes, setReportes] = useState([])


    useEffect(() => {
        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({coleccion: 'reportes', wheres: w}).then((dox) => {
            if (dox.res) {
                setReportes(dox.data)
            }
        })
    }, []);
    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            spacing={4}
            size={12}>

            {reportes.map((item, index) => (
                <Grid2 container key={`WE${index}`} size={{xs: 12, sm: 12, md: 4}}>
                    <Tarjeta_Documentacion_Informacion
                        item={item}
                    />
                </Grid2>
            ))}

        </Grid2>
    )

}
export default Lista_Tarjeta_Documentacion_Informacion